import { createSlice } from "@reduxjs/toolkit";

type ShopListType = {
  shopId: number;
  sent: boolean;
};

type ProductListType = {
  productId: number;
  sent: boolean;
};

type LikedType = {
  shopList: ShopListType[];
  productList: ProductListType[];
};

const initialState: LikedType = {
  shopList: [],
  productList: [],
};

const likedSlice = createSlice({
  name: "liked",
  initialState,
  reducers: {
    likeOrDislike: (state, action) => {
      const { payload } = action;
      switch (payload.type) {
        case "shop": {
          state.shopList = state.shopList.some(
            (item) => item.shopId === payload.shopId,
          )
            ? state.shopList.filter((item) => item.shopId !== payload.shopId)
            : [
                ...state.shopList,
                { shopId: payload.shopId, sent: payload.sent },
              ];
          break;
        }
        case "product": {
          state.productList = state.productList.some(
            (item) => item.productId === payload.productId,
          )
            ? state.productList.filter(
                (item) => item.productId !== payload.productId,
              )
            : [
                ...state.productList,
                { productId: payload.productId, sent: payload.sent },
              ];
          break;
        }
        default:
          break;
      }
    },
    setLikedList: (state, action) => {
      const { payload } = action;
      switch (payload.type) {
        case "shop": {
          state.shopList = payload.list;
          break;
        }
        case "product": {
          state.productList = payload.list;
          break;
        }
        default: {
          break;
        }
      }
    },
    updateLikedList: (state, action) => {
      const { payload } = action;
      switch (payload.type) {
        case "shop": {
          state.shopList = state.shopList.map((item) => {
            const currentItemInPayloadList = payload.list.find(
              (listItem: ShopListType) => listItem.shopId === item.shopId,
            );
            if (currentItemInPayloadList) {
              return { ...item, ...currentItemInPayloadList };
            }
            return item;
          });
          break;
        }
        case "product": {
          state.productList = state.productList.map((item) => {
            const currentItemInPayloadList = payload.list.find(
              (listItem: ProductListType) =>
                listItem.productId === item.productId,
            );
            if (currentItemInPayloadList) {
              return { ...item, ...currentItemInPayloadList };
            }
            return item;
          });
          break;
        }
        default: {
          break;
        }
      }
    },
    clearFullLiked: (state) => {
      state.shopList = initialState.shopList;
      state.productList = initialState.productList;
    },
  },
});

export const { likeOrDislike, setLikedList, clearFullLiked, updateLikedList } =
  likedSlice.actions;

export default likedSlice.reducer;
